import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import DevicesTableSection from "./DevicesTableSection";
import { withMainLayout } from "../view/LayoutHOCs";
import AddDeviceModal from "./add-device-modal/AddDeviceModal";
import { InfoBoxes } from "../info-boxes/InfoBoxes";
// import * as urlService from "../view/urlService";
import { useHistory } from "react-router-dom";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Devices",
        redirectTo: "/devices",
        // iconClassName: "icon-home"
    }
]

function DevicesPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Devices')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <AddDeviceModal />
            <InfoBoxes />
            <DevicesTableSection />
        </>
    );
}


export default withMainLayout(connect()(DevicesPage));
